import apiClient from "../../lib/apiClient";

export const reviewsAPI = {
  // GET /api/reviews
  getReviews: async (params = {}) => {
    try {
      const response = await apiClient.get("/reviews", { params });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Lấy danh sách review thất bại",
      };
    }
  },

  // GET /api/reviews/:id
  getReview: async (id) => {
    try {
      const response = await apiClient.get(`/reviews/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error("Error fetching review:", {
        id,
        status: error.response?.status,
        statusText: error.response?.statusText,
        message: error.response?.data?.message,
        fullError: error.response?.data,
      });

      return {
        success: false,
        error:
          error.response?.data?.message ||
          `Lỗi ${
            error.response?.status || "không xác định"
          }: Không thể tải thông tin review`,
      };
    }
  },

  // POST /api/reviews
  createReview: async (reviewData) => {
    try {
      const response = await apiClient.post("/reviews", reviewData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Tạo review thất bại",
      };
    }
  },

  // PUT /api/reviews/:id
  updateReview: async (id, reviewData) => {
    try {
      const response = await apiClient.put(`/reviews/${id}`, reviewData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Cập nhật review thất bại",
      };
    }
  },

  // DELETE /api/reviews/:id
  deleteReview: async (id) => {
    try {
      const response = await apiClient.delete(`/reviews/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Xóa review thất bại",
      };
    }
  },

  // POST /api/reviews/:id/helpful
  markHelpful: async (id, helpful) => {
    try {
      const payload = helpful !== undefined ? { helpful } : {};
      const response = await apiClient.post(`/reviews/${id}/helpful`, payload);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Đánh dấu thất bại",
      };
    }
  },

  // GET /api/reviews/:id/my-vote
  getMyVote: async (id) => {
    try {
      const response = await apiClient.get(`/reviews/${id}/my-vote`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Lấy thông tin vote thất bại",
      };
    }
  },

  // GET /api/reviews/user/:userId/school/:schoolId/check
  checkUserReview: async (schoolId) => {
    try {
      const response = await apiClient.get(`/reviews/check/${schoolId}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || "Kiểm tra review thất bại",
      };
    }
  },
};
